import type { EmailDelivery } from '~/types/emailDelivery';

const PATH = '/builder/email_deliveries';

type EmailDeliveryResult = {
  email_deliveries: EmailDelivery[];
  total: number;
}

export type EmailDeliveriesListParams = {
  filter?: Record<string, any>;
  limit?: number;
  page?: number;
  order_by?: Record<string, 'asc' | 'desc'>;
}

type EmailDeliveries = {
  list: (params?: EmailDeliveriesListParams) => Promise<EmailDeliveryResult>;
}

export const emailDeliveries = ($http: HttpApi): EmailDeliveries => ({
  list: (params = {}) => $http.$get(PATH, { params }),
});
